//  Footnote back to reference link
var FootnoteBackLink = {

	selectorContainer: '.img-block',
	selector: '.img-note li a[id]',
	selectorLabel: '[aria-describedby="footnote-label"]',
	newLabelAttr: '',

	init: function () {

		// return if the container share not present
		if (!$(this.selector).length) return;

		this.getElements();
		this.bindKeyboard();

	},

	getElements: function () {
		var labelTracker = {}; // Object to track label counts

		$(this.selectorLabel).each(function () {
			var $thisLabel = $(this),
				labelAttr = $thisLabel.attr('href').substring(1), // Get the label text without '#'
				labelText = $thisLabel.text(),
				$thisContainer = $thisLabel.closest(FootnoteBackLink.selectorContainer),
				$thisFootnotes = $thisContainer.find(FootnoteBackLink.selector);

			// Initialize or increment the label count
			if (labelTracker[labelAttr]) {
				labelTracker[labelAttr].count++;
				labelTracker[labelAttr].isDuplicate = true;
			} else {
				labelTracker[labelAttr] = { count: 0, isDuplicate: false };
			}

			var newLabelId = 'label-' + labelAttr + '-' + labelTracker[labelAttr].count;
			$thisLabel.attr('id', newLabelId); // Update the id attribute

			$thisFootnotes.each(function () {
				var thisID = $(this).attr('id');
				if (thisID === labelAttr) {
					var $thisLiParent = $(this).parent();
					FootnoteBackLink.createElement($thisLiParent, newLabelId, labelText);
				}
			});
		});
	},

	updateAttr: function ($thisLabel, newId) {
		// Update the aria-describedby attribute with the new ID
		$thisLabel.attr('id', newId);
	},

	createElement: function ($thisLiParent, thisID, lablelText) {

		// Create the new anchor link
		var newLink = ' <a href="#' + thisID + '" aria-label="Back to reference ' + lablelText + '" class="footnote-back" >&#8617; </a>';

		// Append the new link to the <li> parent
		$thisLiParent.append(newLink);
	},

	bindKeyboard: function () {

		$('body').on('keyup', function () {

			$('body').addClass('js-keyboard-active');

		});
	}
};

$(document).ready(function () {

	FootnoteBackLink.init();

});